// Packages and components
import React, { useState } from 'react';
import { Box, Image } from 'grommet';
import { Copy, StatusGood } from 'grommet-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SHDButton from '@ui/Button/SHDButton';
import SHDCallout from '@ui/Callout/SHDCallout';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';

// Helpers and utilities
import { SIDELINE_APP_URLS } from '@constants/strings';

// Types and interfaces
import type { GoProModalProps } from './../schedule.d';

const GoProModal: React.FC<GoProModalProps> = ({
  appHost,
  appHostService,
  onClose,
  capture,
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  return (
    <>
      <SHDModalContainer gap="xlarge">
        <Box gap="xxsmall">
          <SHDHeading level={3} formatCasing={false}>
            GoPro streaming link
          </SHDHeading>
          <SHDText style="subhead" color="black-alpha-80">
            Click the link below to copy RTMP URL, then click the button labeled
            &ldquo;Open GoPro Quik&rdquo; below. Enter the information as show
            in the screenshot below, then press Set Up Live Stream.
          </SHDText>
        </Box>
        <CopyToClipboard
          text={capture.rtmp?.fullUrl_GoPro_TX as string}
          onCopy={() => {
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 9000);
          }}
        >
          <Box style={{ cursor: 'pointer', zIndex: 10 }}>
            <SHDCallout background="gray-50">
              <Box
                direction="row"
                justify="between"
                width="100%"
                align="center"
              >
                <SHDText style="body" truncate>
                  {capture.rtmp?.fullUrl_GoPro_TX}
                </SHDText>

                {!copied ? (
                  <Copy size="24px" color={'black-alpha-80'} />
                ) : (
                  <StatusGood size="24px" color={'black-alpha-80'} />
                )}
              </Box>
            </SHDCallout>
          </Box>
        </CopyToClipboard>

        <Box round="4px" overflow="hidden">
          <Image src="/gopro_rtmpinfo.png" />
        </Box>
      </SHDModalContainer>
      <SHDFooter>
        <SHDModalContainer gap="xxsmall">
          <SHDButton
            primary
            label={`Open GoPro Quik`}
            disabled={!copied}
            onClick={() => {
              onClose();
              if (appHost.isHosted) {
                appHostService?.notifications.openAppLink(
                  SIDELINE_APP_URLS.goProOneLink
                );
              } else {
                window.location.href = SIDELINE_APP_URLS.goProOneLink;
              }
            }}
          />
          <SHDButton
            secondary
            label="Cancel"
            onClick={() => {
              onClose();
            }}
          />
        </SHDModalContainer>
      </SHDFooter>
    </>
  );
};
export default GoProModal;
